import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT } from 'src/utils/helper';
import { ANTRAGS_STATUS } from 'src/lib/constants/constant';

function VorDerForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Vor der Förderung'}>
				<MeinBereichButton
					buttonName='Neuen Antrag einreichen'
					onClick={() => {
						navigate(PAGES_URLS.FoerderProgramm);
					}}
				/>
				<MeinBereichButton
					buttonName='Einen Antrag bearbeiten'
					onClick={() => {
						navigate(PAGES_URLS.MeineFoerderung, {
							state: {
								filter: {
									items: [
										{ field: 'Antragstatus_Antragstatus', operator: 'is', value: 'in Bearbeitung' },
										{ field: 'Antragstatus_Antragstatus', operator: 'is', value: enumT(ANTRAGS_STATUS.inUeberarbeitungDurchAntragssteller) },
									],
									logicOperator: 'or',
									// quickFilterLogicOperator: 'or',
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName='eingereichte Anträge einsehen'
					onClick={() => {
						navigate(PAGES_URLS.MeineFoerderung, {
							state: {
								filter: {
									items: [
										{
											field: 'Allgemein_Eingangsnummer',
											operator: 'isNotEmpty',
										},
									],
								},
							},
						});
					}}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default VorDerForderung;
